import { LegalLayout } from "../components/LegalLayout";

const SECTIONS = [
  { h: "Acceptance of Terms", p: [
    "By accessing or using yeswecanlending.com, you agree to these Terms & Conditions. If you do not agree, do not use this site.",
  ]},
  { h: "No Financial or Loan Advice", p: [
    "Content on this site, including any webinar, guide, or download, is for general educational purposes only. It is not a loan commitment, pre-approval, or guarantee of any specific loan terms, interest rate, or closing timeline. All loans are subject to underwriting approval.",
  ]},
  { h: "Not a Loan Application", p: [
    "Registering for a webinar, downloading a guide, or submitting a contact form does not constitute a mortgage loan application and does not obligate you to work with Velisa Johnson or Yes We Can Lending Corporation LLC.",
  ]},
  { h: "Equal Housing Opportunity", p: [
    "Yes We Can Lending Corporation LLC is an Equal Housing Lender/Opportunity company. We do not discriminate on the basis of race, color, religion, sex, handicap, familial status, or national origin.",
  ]},
  { h: "NMLS Disclosure", p: [
    "Velisa Johnson, NMLS #2656519; Yes We Can Lending Corporation LLC, NMLS #2656519. Licensed in Nevada and Texas. Verify licensing at nmlsconsumeraccess.org.",
  ]},
  { h: "Intellectual Property", p: [
    "All content on this site (text, graphics, logos, videos) is owned by or licensed to Yes We Can Lending Corporation LLC and may not be reproduced without written permission.",
  ]},
  { h: "No Warranty", p: [
    "This site and its content are provided \u201cas is\u201d without warranties of any kind, express or implied, including accuracy, completeness, or fitness for a particular purpose.",
  ]},
  { h: "Limitation of Liability", p: [
    "To the fullest extent permitted by law, Yes We Can Lending Corporation LLC is not liable for any indirect, incidental, or consequential damages arising from your use of this site.",
  ]},
  { h: "Third-Party Links", p: [
    "This site may link to third-party sites; we are not responsible for their content or privacy practices.",
  ]},
  { h: "Governing Law", p: [
    "These terms are governed by the laws of the State of Nevada, without regard to conflict-of-law principles.",
  ]},
  { h: "Changes to These Terms", p: [
    "We may update these terms at any time; continued use of the site after changes constitutes acceptance.",
  ]},
  { h: "Contact Us", p: [
    "Yes We Can Lending Corporation LLC, [[NEEDS CONFIRMATION — business address]], velisa.yeswecan@gmail.com.",
  ]},
];

export default function Terms() {
  return (
    <LegalLayout
      title="Terms & Conditions"
      subtitle="Yes We Can Lending Corporation LLC — Effective August 1, 2026"
      sections={SECTIONS}
      testId="terms-page"
    />
  );
}
